import { render, staticRenderFns } from "./VolunteerApply.vue?vue&type=template&id=33a741ce&scoped=true"
import script from "./VolunteerApply.vue?vue&type=script&lang=js"
export * from "./VolunteerApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a741ce",
  null
  
)

export default component.exports